/*
 Created by zhihao_su on 2019/3/13.
*/
import Vue from "vue"
import Router from "vue-router"
import { defaultRoutes } from "./conifg"
import config from "@/config"
import store from "@/store"
import PubUIModule from "@/store/pubui"
import { getUrlParam } from "@/utils"
import Message from "@/utils/message"
Vue.use(Router)

const createRouter = () =>
    new Router({
        mode: "history",
        base: process.env.VUE_APP_BASE_PATH,
        routes: defaultRoutes,
        linkActiveClass: "active",
        linkExactActiveClass: "active"
    })
const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    // @ts-ignore
    router.matcher = newRouter.matcher // 新路由实例matcer，赋值给旧路由实例的matcher，（相当于replaceRouter）
}
// 路由权限判断
router.beforeEach(async (to, from, next) => {
    // 设置标题
    document.title = to.meta.title || "软件开发管理平台"
    // 获取token
    const env = process.env.VUE_APP_ENV || "dev"
    // 兼容本地开发获取token
    if (env === "dev") {
        const token = getUrlParam("token")
        if (token) {
            localStorage.setItem("token", token)
        }
    }
    //if (hasToken) {
    window.fLog.log("page", to.path)
    // 检查路由是否需要登录验证
    if (to.meta && to.meta.noAuth) {
        // 无需登录验证的路由，直接放行
        next()
        return
    }
    if (to.path === "/login") {
        next({ path: "/" })
    } else if (to.path === "/error/404") {
        next()
    } else {
        const hasUserInfo = store.getters.name
        if (hasUserInfo) {
            window.fLog.uidConfig(store.getters.uid)
            if (to.path === "/error/404") {
                next({ path: "/" })
            } else {
                next()
            }
        } else {
            try {
                await store.dispatch("user/getUserInfo")
                await store.dispatch("common/getEnums")
                store.dispatch("user/getUserList")
                store.dispatch("user/getOrgUserList")
                store.dispatch("user/getOrgList")
                await store.dispatch("permission/getAsyncPermissionRoutes", store.state.user)
                const asyncPermissionRoute = store.state.permission.addRoutes
                router.addRoutes(asyncPermissionRoute)
                PubUIModule.registerModule(store, config.api.PID)
                next({ ...to, replace: true })
            } catch (err) {
                Message.error(err)
                if (store.getters.noPermission) {
                    next({ path: "/error/404" })
                }
            }
        }
    }
})
export default router
